export function getStrokeColorToUse(diagnosticType, location) {

    let red = "#FF0000";
    let yellow = "#FFFF00";
    let blue = "#0000FF";
 
    // GPS Quality Values
    const GPS_QUALITY_POOR_THRESHOLD = 1.0; // 0.0 to 1.0

    // WiFiSignal Strength
    const WIFI_NO_SIGNAL_THRESHOLD = -90;
    const WIFI_VERY_LOW_THRESHOLD = -80;
    const WIFI_LOW_THRESHOLD = -71;

    let colorToUse = red;
    switch (diagnosticType) {
      case 1:
        colorToUse = "yellow";
        break;
      case 2:
        colorToUse = red;
        break;
      case 3:
        colorToUse =
          location.GpsQuality > GPS_QUALITY_POOR_THRESHOLD ? yellow : red;
        break;
      case 4:
        if (
          location.WiFiSignalStrength > WIFI_NO_SIGNAL_THRESHOLD &&
          location.WiFiSignalStrength < WIFI_VERY_LOW_THRESHOLD
        ) {
          colorToUse = red;
        } else if (location.WiFiSignalStrength < WIFI_LOW_THRESHOLD) {
          colorToUse = yellow;
        } else {
          colorToUse = blue;
        }
        break;
      default:
          colorToUse = red;
          break;
    }
    return colorToUse;
  }